import { z } from 'zod';

export const staffClientEpisodeSchema = z.object({
  firstName: z.string().trim().min(1),
  lastName: z.string().trim().min(1),
  email: z.string().trim().email(),
  dateOfBirth: z.string().min(1),
  zip: z.string().trim().min(1),
  organizationId: z.string().min(1),
  practitionerId: z.string().min(1),
  therapyTypeCode: z.string().min(1),
});

export type StaffClientEpisodeForm = z.infer<typeof staffClientEpisodeSchema>;
